import React from "react";
import { ListActionProvider } from "../actions/list/ListActionContext";
import { EditActionProvider } from "../actions/edit/EditActionContext";
import { RemoveActionProvider } from "../actions/remove/RemoveActionContext";
import { CreateActionProvider } from "../actions/create/CreateActionContext";
import TagsPage from "../pages/TagsPage";



export default function TagsRouterWrapper(props: { filters?: any, formDefaultValues?: any, formFilterValues?: any }) {
    const { filters, formDefaultValues, formFilterValues } = props;
    return (
      <ListActionProvider>
          <EditActionProvider>
              <RemoveActionProvider>
                  <CreateActionProvider>
                      <TagsPage filters={filters} formDefaultValues={formDefaultValues} formFilterValues={formFilterValues} />
                  </CreateActionProvider>
              </RemoveActionProvider>
          </EditActionProvider>
      </ListActionProvider>
    );
};
